const isValidComponent = require('./component');
const isValidSection = require('./section');
const isValidFunnel = require('./funnel');

module.exports = {
    isValidComponent,
    isValidSection,
    isValidFunnel,
};
